import React from "react"
import { Tooltip } from "@material-ui/core"
import { CheckCircle as CheckIcon, Error as AlertIcon } from "@material-ui/icons"

import useStyles from "@/pages/Attendance/Chat/ConversationPanel/ClientInfo/ClientBoard/StatusConfirmationModal/RequiredFieldIndicator/styles"

export type RequiredFieldIndicatorProps = {
	isFilled: boolean
	isRequired: boolean
	label: string
}

const RequiredFieldIndicator: React.FC<RequiredFieldIndicatorProps> = (props) => {
	const { isFilled, isRequired, label } = props
	const classes = useStyles()

	if (!isRequired) {
		return null
	}

	const tooltipTitle = isFilled
		? `${label} preenchido`
		: `${label} é obrigatório`

	const icon = isFilled
		? <CheckIcon className={classes.filledIcon} />
		: <AlertIcon className={classes.alertIcon} />

	return (
		<Tooltip title={tooltipTitle}>
			{icon}
		</Tooltip>
	)
}

export default RequiredFieldIndicator
